<template>
    <div class="checkbox-wrapper">
        <v-expansion-panels v-model="expanded" style="background-color: transparent">
            <v-expansion-panel expand>
                <v-expansion-panel-title class="v-subheader theme--light">
                    {{ $t(`filterTitles.${filter}`) }}
                </v-expansion-panel-title>
                <v-expansion-panel-text class="pt-4">
                    <v-row class="checkbox-container">
                        <slot />
                        <v-col v-for="(group, groupName) in groupedValues" :key="groupName" cols="12" class="pe-4 py-0">
                            <span
                                class="text-caption font-weight-bold text--secondary"
                                v-text="
                                    $te(`service.${groupName.toLowerCase()}`)
                                        ? $t(`service.${groupName.toLowerCase()}`)
                                        : capitalizeTheFirstLetterOfEachWord(groupName)
                                "
                            />
                            <div v-for="(item, index) in group" :key="`${index}-${item.value}`">
                                <v-checkbox
                                    v-model="checked"
                                    small
                                    :hide-details="true"
                                    class="py-0 my-0"
                                    :value="item.value"
                                    density="compact"
                                    :ripple="!$breakpoint.smAndDown"
                                >
                                    <template v-slot:label>
                                        <div class="d-flex label-wrapper full-width ms-2">
                                            <div class="label-text">
                                                {{ getValue(item) }}
                                            </div>
                                        </div>
                                    </template>
                                    <template v-slot:append>
                                        <div class="ms-auto filter-qty font-weight-bold">
                                            {{ `${item.count}` }}
                                        </div>
                                    </template>
                                </v-checkbox>
                            </div>
                        </v-col>
                    </v-row>
                    <v-btn
                        v-if="values.length > showLimit"
                        block
                        size="x-small"
                        variant="text"
                        class="mt-6"
                        @click="showAll = !showAll"
                    >
                        {{ showAll ? $t('hide') : $t('show') }} {{ $t('all') }}
                    </v-btn>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-divider />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {CheckboxFilter} from '@/components/search/filters/CheckboxFilter.vue'
    import {capitalizeTheFirstLetterOfEachWord} from '@/utils/helpers'

    @Component
    export class CheckboxFilterGrouped extends CheckboxFilter {
        capitalizeTheFirstLetterOfEachWord(val) {
            return capitalizeTheFirstLetterOfEachWord(val.toLowerCase())
        }

        get groupedValues() {
            const grouped = {}

            this.partOfValues.forEach(filterValue => {
                if (filterValue.groupName) {
                    grouped[filterValue.groupName]
                        ? grouped[filterValue.groupName].push(filterValue)
                        : (grouped[filterValue.groupName] = [filterValue])
                } else {
                    grouped.other ? grouped.other.push(filterValue) : (grouped.other = [filterValue])
                }
            })

            return grouped
        }
    }

    export default CheckboxFilterGrouped
</script>

<style lang="scss" scoped>
    .label-wrapper {
        width: 100%;
    }

    .label-text {
        font-size: 13px;
    }

    .checkbox-container {
        max-height: 500px;
        overflow: auto;
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #ddd;
        border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #6699cc;
        border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #b3d4fc;
    }

    :deep(.v-input__append-outer) {
        margin-left: auto;
    }

    .filter-qty {
        color: grey;
        font-size: 10px;
    }

    :deep(.v-expansion-panel-content__wrap) {
        padding: 0;
    }
</style>
